// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumbs-item b,.breadcrumbs-item em,.breadcrumbs-item i,.breadcrumbs-item p,.breadcrumbs-item strong{display:inline;font-weight:400;font-style:normal}.continue-alert>.ui-row>.ui-col{min-width:100%;.ui-button{margin-left:auto}.ui-icon{cursor:pointer}}", ""]);
// Exports
module.exports = exports;
